import { render } from "./AddPaymentLink.vue?vue&type=template&id=1c2706e3"
import script from "./AddPaymentLink.vue?vue&type=script&lang=js"
export * from "./AddPaymentLink.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__